import Select from "react-select";

const dropdownStyles = {
  container: (baseStyles, state) => ({
    ...baseStyles,
    height: 40,
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    border: "1px solid #acb5bc",
    height: 40,
  }),
  valueContainer: (baseStyles, state) => ({
    ...baseStyles,
    height: 40,
    paddingTop: 0,
    paddingBottom: 0,
    fontSize: 14,
    color: "#5a5a62",
  }),
  placeholder: (baseStyles, state) => ({
    ...baseStyles,
    overflow: "visible",
  }),
  input: (baseStyles, state) => ({
    ...baseStyles,
    height: 40,
    marginTop: 0,
    marginBottom: 0,
  }),
  singleValue: (baseStyles, state) => ({
    ...baseStyles,
    overflow: "visible",
  }),
  indicatorSeparator: (baseStyles, state) => ({
    display: "none",
  }),
};

const ReactSelect = ({ disabled, ...props }) => (
  <Select styles={dropdownStyles} {...props} isDisabled={disabled} />
);

export default ReactSelect;
